import React, { useState } from 'react';
import '../App.css';
import Header from './Header';
import Footer from './Footer';

function FAQ() {
    const [openQuestion, setOpenQuestion] = useState(null);

    const toggleQuestion = (index) => {
        if (openQuestion === index) {
            setOpenQuestion(null);
        } else {
            setOpenQuestion(index);
        }
    };

    const faqItems = [
        {
            question: "What is Quokka?",
            answer: "Quokka is a platform that helps businesses analyze and understand their data more effectively through advanced AI solutions."
        },
        {
            question: "Do you offer a free demo?",
            answer: "Yes, we offer a 3 month demo, where you have access to all our features for free and you can see how Quokka can benefit your business."
        },
        {
            question: "Can I trust Quokka to provide accurate answers?",
            answer: "Absolutely. Our AI models are trained on high-quality data and continuously improved to ensure accuracy. We also provide confidence scores with our analyses so you know when to verify results."
        },
        {
            question: "What file types does Quokka support?",
            answer: "Quokka supports various file formats including CSV, Excel, JSON, and SQL database connections. We're constantly adding support for more formats."
        },
        {
            question: "What is your refund policy?",
            answer: "Our refund policy is simple: while we don't offer refunds, we do provide a three-month trial period so you can fully experience Quokka. Cancel anytime during or after the demo if it's not right for you."
        }
    ];

    return (
        <div className="faq-page">
            <Header />
            <div className="faq-container">
                <div className="faq-header">
                    <h1>Frequently Asked Questions</h1>
                </div>
                <div className="faq-content">
                    <div className="faq-list">
                        {faqItems.map((item, index) => (
                            <div className="faq-item" key={index}>
                                <button 
                                    className={`faq-question ${openQuestion === index ? 'active' : ''}`}
                                    onClick={() => toggleQuestion(index)}
                                >
                                    <span>{item.question}</span>
                                    <span className="faq-icon">{openQuestion === index ? '−' : '+'}</span>
                                </button>
                                {openQuestion === index && (
                                    <div className="faq-answer">
                                        <p>{item.answer}</p>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                    {/* <div className="faq-more">
                        <a href="/contact" className="faq-more-link">
                            More FAQs →
                        </a>
                    </div> */}
                </div>
            </div>
            {/* <Footer /> */}
        </div>
    );
}

export default FAQ;
